import { useEffect } from 'react';
import { isAnswerPresent } from 'site-modules/shared/components/incentives/incentives-wizard/utils/answer-status';

export const useSavedAnswer = (stepConfig, answers, setValue) => {
  const { id } = stepConfig;

  useEffect(() => {
    if (isAnswerPresent(id, answers)) {
      setValue(answers[id][0]);
    }
  }, [answers, id, setValue]);
};
